import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Tab, TabValue } from './interfaces/tab.interface';

@Component({
  selector: 'app-tabs-v2',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TabsV2Component implements OnInit {
  @Input() customClass: string = '';
  @Input() tabList: Tab<TabValue>[] = [];
  @Output() onSelectTab = new EventEmitter();
  protected selectedTab!: Tab<TabValue>;

  ngOnInit(): void {
    this.tabList.some((tab: Tab<TabValue>, index: number) => {
      if (tab.default) {
        this.selectedTab = tab;

        this.onSelectTab.emit(this.tabList[index]);
      }
    });
  }

  changeTab(tab: Tab<TabValue>): void {
    if (tab.disabled) {
      return;
    }

    this.selectedTab = tab;
    this.onSelectTab.emit(this.selectedTab);
  }
}
